// The local practitioner profile (docs/plans/phase1-consultation.md §3.3 C4, §7.4, P13).
import { queryOptions } from '@tanstack/react-query';
import {
  myPractitionerSchema,
  practitionerListSchema,
  practitionerViewSchema,
  type SavePractitionerRequest,
} from '@wodi/shared';

import { api } from './client.ts';

export const practitionerKeys = {
  list: ['practitioners'] as const,
  me: ['me', 'practitioner'] as const,
};

export const practitionersQuery = queryOptions({
  queryKey: practitionerKeys.list,
  queryFn: () => api('GET', '/admin/practitioners', { schema: practitionerListSchema }),
});

export const myPractitionerQuery = queryOptions({
  queryKey: practitionerKeys.me,
  queryFn: () => api('GET', '/me/practitioner', { schema: myPractitionerSchema }),
  staleTime: 300_000,
});

export function savePractitioner(userId: string, body: SavePractitionerRequest) {
  return api('PUT', `/admin/practitioners/${userId}`, { body, schema: practitionerViewSchema });
}

export function saveLicenceWarningDays(licenceWarningDays: number) {
  return api('PUT', '/admin/practitioner-settings', {
    body: { licenceWarningDays },
    schema: practitionerListSchema,
  });
}
